// API routes config
// When running on localhost (e.g. npm start on :5173), use local backend.
// Override with VITE_API_URL in .env for any environment.
const origin = typeof window !== 'undefined' ? window.location.origin : ''
const isLocalDev = origin.startsWith('http://localhost:') || origin.startsWith('http://127.0.0.1:')
const API_URL =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL)
    ? import.meta.env.VITE_API_URL.replace(/\/$/, '')
    : isLocalDev
      ? 'http://localhost:8008/api'
      : `${origin || ''}/api`

export const API_BASE_URL = API_URL

/** Origin of the Django app (admin, static). API_URL is …/api → strip /api for admin links. */
export function djangoAdminBaseUrl() {
  return API_URL.replace(/\/?api\/?$/, '') || API_URL
}

export const DJANGO_ADMIN_CATALOG_BUNDLES = `${djangoAdminBaseUrl()}/admin/catalog/catalogbundle/`

export const API = {
    USER_ME: API_URL + '/users/me/',
    LOGIN: API_URL + '/users/login/',
    REFRESH: API_URL + '/users/login/refresh/',
    VERIFY: API_URL + '/users/login/verify/',
    //REGISTER: API_URL + '/public/user_register/',
    ACTIVATION: API_URL + '/users/activation/',
    RESEND_ACTIVATION: API_URL + '/users/resend_activation/',
    RESET_PASSWORD: API_URL + '/users/reset_password/',
    RESET_PASSWORD_CONFIRM: API_URL + '/users/reset_password_confirm/',
    SET_PASSWORD: API_URL + '/users/set_password/',
    ATTACHMENTS: API_URL + '/core/attachments/',
    ATTACHMENTS_BULK: API_URL + '/core/attachments/bulk/',
    CHOICES: API_URL + '/core/choices/',
    LEADS: API_URL + '/sales/leads/',
    SALES_ORDERS: API_URL + '/sales/orders/',
    PARTNERS_APPLICATIONS: API_URL + '/sales/partners/',
    SERVICE_REQUESTS: API_URL + '/sales/service_requests/',

    // Control plane (core, billing, invoices)
    BUSINESS_DETAILS: API_URL + '/core/business_details/',
    BILLING_SUMMARY: API_URL + '/core/billing-summary/',
    DASHBOARD_EXECUTIVE_SUMMARY: API_URL + '/core/dashboard/summary/',
    DASHBOARD_OPERATOR_SERIES: API_URL + '/core/dashboard/operator-series/',
    UNIFIED_ORDERS: API_URL + '/core/unified-orders/',
    SERVICE_INSTANCES: API_URL + '/core/service_instances/',
    COMMERCIAL_LINKS: API_URL + '/core/commercial_links/',
    PROVISIONING_JOBS: API_URL + '/core/provisioning_jobs/',
    RUNTIME_HOSTS: API_URL + '/core/runtime_hosts/',
    DATABASE_HOSTS: API_URL + '/core/database_hosts/',
    HOST_DEFAULT_POLICIES: API_URL + '/core/host_default_policies/',
    SUBSCRIPTIONS: API_URL + '/billing/subscriptions/',
    ADDITIONAL_ORDERS: API_URL + '/billing/additional_orders/',
    SNAPSHOTS: API_URL + '/billing/snapshots/',
    BILLABLE_RECORDS: API_URL + '/billing/billable_records/',
    USAGE_AGGREGATES: API_URL + '/billing/usage_aggregates/',
    USAGE_UNIT_PRICES: API_URL + '/billing/usage_unit_prices/',
    USAGE_EVENTS: API_URL + '/billing/usage_events/',
    PAYMENT_METHODS: API_URL + '/billing/payment_methods/',
    INVOICE_PREVIEW: API_URL + '/billing/invoice_preview/',
    INVOICE_PAYLOAD: API_URL + '/billing/invoice_payload/',
    USAGE_BILLING_PREVIEW: API_URL + '/billing/usage_billing_preview/',
    CONVERT_USAGE_TO_BILLABLES: API_URL + '/billing/convert_usage_to_billables/',
    INVOICES_MONTHLY_STATS_PULL: API_URL + '/billing/integrations/invoices/monthly-stats/pull/',
    MONTHLY_SNAPSHOT_DETAIL: API_URL + '/billing/monthly-snapshots/',
    MONTHLY_SNAPSHOT_NORMALIZE: API_URL + '/billing/monthly-snapshots/normalize/',
    MONTHLY_SNAPSHOT_MONTH_CLOSE_REFRESH: API_URL + '/billing/monthly-snapshots/month-close-refresh/',
    BILLING_RUNS: API_URL + '/billing-runs/',
    MONTH_CLOSE_CYCLES: API_URL + '/billing/month-close-cycles/',
    MONTH_CLOSE_MASTER_REPORT: API_URL + '/billing/month-close-master-report/',
    INVOICES: API_URL + '/invoices/',
    /** Superuser: issuer/supplier legal + pay-to bank for invoice service handshake */
    INVOICE_SUPPLIER_PROFILE: API_URL + '/invoices/supplier-profile/',
    PLATFORM_BINDINGS: API_URL + '/v1/platform/bindings/',
    PLATFORM_BILLING_ACCOUNTS: API_URL + '/v1/platform/billing-accounts/',
    PLATFORM_PROVISIONING_PLANS: API_URL + '/v1/platform/provisioning-plans/',
    SELF_SERVICE_ONBOARDING_START: API_URL + '/public/self-service-onboarding/start/',
    /** @deprecated Public one-step complete — use register + verified complete */
    SELF_SERVICE_ONBOARDING_COMPLETE: API_URL + '/public/self-service-onboarding/complete/',
    SELF_SERVICE_ONBOARDING_REGISTER: API_URL + '/public/self-service-onboarding/register/',
    SELF_SERVICE_ONBOARDING_STATUS: API_URL + '/core/self-service-onboarding/status/',
    SELF_SERVICE_ONBOARDING_COMPLETE_VERIFIED: API_URL + '/core/self-service-onboarding/complete/',
    /** Invoice Service collection rail (provider-neutral; active provider chosen server-side). */
    COLLECTION_SETUP_SESSIONS: API_URL + '/core/collection/setup-sessions/',
    COLLECTION_READINESS: API_URL + '/core/collection/readiness/',
    COLLECTION_PLATFORM_PSP: API_URL + '/core/collection/platform-psp/',
    COLLECTION_PROVIDER: API_URL + '/core/collection/provider/',
    COLLECTION_PROJECTIONS: API_URL + '/core/collection/projections/',
    COLLECTION_RECURRING_CHARGE: API_URL + '/core/collection/recurring-charge/',
    /** Staff/superuser: semiautomatic monthly recurring mandate batch */
    COLLECTION_OPERATOR_MONTHLY_RECURRING_BATCH: API_URL + '/core/collection/operator/monthly-recurring-batch/',
    COLLECTION_RUNS: API_URL + '/core/collection/runs/',
    /** Superuser: Invoice Service URL, M2M bearer, Mollie key proxy, default PSP */
    INVOICE_SERVICE_OPERATOR_INTEGRATION: API_URL + '/core/operator/invoice-service-integration/',
    /** Superuser: filterable cross-tenant commercial / billing activity */
    OPERATOR_ACTIVITY_FEED: API_URL + '/core/operator/activity-feed/',
    CONTROL_PLANE_CONTRACT_INDEX: API_URL + '/core/contracts/index/',
    LIFECYCLE_NOTIFICATION_RELIABILITY_SUMMARY: API_URL + '/core/lifecycle-notifications/reliability-summary/',
    IDENTITY_MAPPING_HEALTH: API_URL + '/core/identity/health/',
    IDENTITY_MAPPING_REPAIR_INSTANCES: API_URL + '/core/identity/repair/instances/',
    COMMERCIAL_LINK_BROKEN_CHAINS: API_URL + '/core/commercial_links/broken-chains/',
    PLATFORM_IDENTITY_RESOLVE_HOST: API_URL + '/v1/platform/identity/resolve-host',
    /** Staff / billing operator: product changelog */
    PULSE_CHANGELOG: API_URL + '/core/pulse/changelog/',
    PULSE_CHANGELOG_SUMMARY: API_URL + '/core/pulse/changelog/summary/',
    PULSE_CHANGELOG_PLATFORM_ORGS: API_URL + '/core/pulse/changelog/platform-organizations/',
    /** Staff: newsletter campaigns + deliveries */
    PULSE_NEWSLETTER_CAMPAIGNS: API_URL + '/core/pulse/newsletter-campaigns/',
    PULSE_NEWSLETTER_SUMMARY: API_URL + '/core/pulse/newsletter/summary/',
    /** Staff: external marketing subscribers directory */
    PULSE_EXTERNAL_SUBSCRIBERS: API_URL + '/core/pulse/external-subscribers/',
    /** Staff: unified tenant + external subscriber directory (Pulse newsletter) */
    PULSE_SUBSCRIBER_DIRECTORY: API_URL + '/core/pulse/subscriber-directory/',
    /** Superuser: catalog bundles (products / programs for collection + subscriptions) */
    CATALOG_BUNDLES: API_URL + '/catalog/bundles/',
    TENANT_BACKUPS: API_URL + '/core/tenant_backups/',
    TENANT_BACKUP_CLEANUP_RUNS: API_URL + '/core/tenant_backups/cleanup-runs/',
    INFRASTRUCTURE_VERSION_REPORTS: API_URL + '/core/infrastructure/version-reports/',
    INFRASTRUCTURE_VERSION_SUMMARY: API_URL + '/core/infrastructure/versions/summary/',
    INFRASTRUCTURE_VERSION_DRIFT: API_URL + '/core/infrastructure/versions/drift/',
    PLATFORM_RELEASES: API_URL + '/core/releases/',
    CELERY_OPS_SNAPSHOT: API_URL + '/core/celery/ops/snapshot/',
    CELERY_OPS_TASK_RUNS: API_URL + '/core/celery/ops/task-runs/',
    CELERY_OPS_TASK_RUNS_RECONCILE: API_URL + '/core/celery/ops/task-runs/reconcile/',
    DASHBOARD_HOST_RESOURCES: API_URL + '/core/dashboard/host-resources/',
}
